import {
  createStore,
  applyMiddleware,
  compose,
  combineReducers,
  Store
} from "redux";
// import thunk from "redux-thunk";
import { routerReducer, routerMiddleware } from "react-router-redux";

import { ApplicationState, reducers } from "../store";
import { History } from "history";
import createSagaMiddleWare from "redux-saga";
import { createLogger } from "redux-logger";
import rootSaga from "../store/sagas";
import { createForms } from 'react-redux-form'
import { getInitialModelValue as initialTruckState } from '../trucks/TruckModels'
import { getEmptyUnitModel as initialUnitState, getEmptyDeleteUnitModel } from '../units/UnitModels'
import { getEmptyFilterSettingsModel as initialFilterSettingsState } from '../common/models/CommonModels'
import { getEmptyLoginModel, getEmptyPasswordModel } from "../login/LoginModels";
import { getEmptyDeleteTruckModel } from "../trucks/TruckModels";
import { RegistrationPromptModel, getEmptyRegisterUserModel } from "../register/user/RegisterUserModels";
import { getEmptyRegisterCompanyModel } from "../register/company/RegisterCompanyModels";
import { getEmptyInfoEmailModel } from "../common/models/InfoEmailModels";


export default function configureStore(history: History, initialState?: ApplicationState) {
  const sagaMiddleWare = createSagaMiddleWare();

  const devMiddleWares = [];
  if (process.env.NODE_ENV === "development") {
    devMiddleWares.push(createLogger());
  }

  const createStoreWithMiddleware = compose(
    applyMiddleware(
      // thunk,
      routerMiddleware(history),
      sagaMiddleWare,
      ...devMiddleWares
    )
  )(createStore);

  // Combine all reducers and instantiate the app-wide store instance
  const allReducers: any = combineReducers(
    Object.assign({}, reducers, { routing: routerReducer }, ...createForms({
      newTruck: initialTruckState(),
      newUnit: initialUnitState(),
      newFilterSetting: initialFilterSettingsState(),
      loginForm: getEmptyLoginModel(),
      deleteTruck: getEmptyDeleteTruckModel(),
      deleteUnit: getEmptyDeleteUnitModel(),
      registrationPrompt: <RegistrationPromptModel>{},
      registerUserModel: getEmptyRegisterUserModel(),
      registerCompanyModel: getEmptyRegisterCompanyModel(),
      changePasswordModel: getEmptyPasswordModel(),
      infoEmail: getEmptyInfoEmailModel()
    }))
  );

  const store = createStoreWithMiddleware(allReducers, initialState) as Store<
    ApplicationState
    >;

  sagaMiddleWare.run(rootSaga, history);

  return store;
}



// WEBPACK FOOTER //
// ./src/utils/configureStore.ts